import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const NotificationCount = ({ notificationCount }) => {
	return (
		<div
			className={cn('label', { 'label-danger': notificationCount > 0, 'label-success': notificationCount === 0 })}
		>{notificationCount}</div>
	);
};

NotificationCount.propTypes = {
	notificationCount: PropTypes.number.isRequired
};

export default NotificationCount;
